import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/impressao`

    return {
        list(queryParms) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        datatable(queryParms) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        getAtendimentosAssinados(atendimentoId) {

            return repository.get(`${baseUrl}/atendimento-assinado/${atendimentoId}`)
        },
        faturarEnfermagem(params) {

            return repository.post(`${baseUrl}/faturar-enfermagem`, params)
        },
    }
}